// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 14 ? "bh-helper-instance" : chunkId) + "-legacy." + {"14":"6557a1c0","152":"1654304c","216":"b2eb9d1d","303":"590aa313","311":"c6223187","400":"302dfd12","726":"bba5dc34","752":"9b11beab","798":"a7f9bf49","928":"b6232d69"}[chunkId] + ".js";
};